export default {
  "multiple-groups_page-title": "Choose the right account",
  "multiple-groups_page-description": "We see that you have multiple IDs for a few accounts. Which one would you like to view?",
  "multiple-groups_form-label_choose-account": "Choose Account",
  "___multiple-groups_action_continue": "",
  "___multiple-groups_text_loading-message": "",
  "multiple-groups_action_done": "Logout",
};